<template  >
  <div class="root"  @keydown.enter="logindo">
    <div class="login-container">
      <Form ref="loginForm" :model="loginForm" :rules="ruleValidate" label-position="left" :label-width="20" >
        <FormItem class="title">
          <h3>系统登陆</h3>
        </FormItem>
        <FormItem  prop="username">
          <Input placeholder="输入登陆账号" size="large" v-model="loginForm.U_NINKNAME"></Input>
        </FormItem>
        <FormItem prop="password">
          <Input type="password" placeholder="输入登陆密码"  size="large" v-model="loginForm.U_PASSWORD"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" long  size="large"  @click="logindo" :disabled="loading">登陆</Button>
        </FormItem>
      </Form>
    </div>

    <table>
      <tr style="font-weight: bold;text-align: center">
        <td colspan=""></td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name:'login',
    data(){
      return{
        loading:false,
        check:false,
        loginForm:{
          U_NINKNAME:'',
          U_PASSWORD:'',
        },
        ruleValidate:{
          U_NINKNAME: [{ required: true, message: '输入登陆账号', trigger: 'blur' }],
          U_PASSWORD: [{ required: true, message: '输入登陆密码', trigger: 'blur' }],
        }
      }
    },
    methods:{
      logindo(){
        this.$refs['loginForm'].validate((valid) => {
          if (valid) {
            this.loading = true;
            let name = this.loginForm.U_NINKNAME;
            let password = this.loginForm.U_PASSWORD;
            let that = this;
            let rember = 0;//不记住密码
            if(this.check){
              rember = 1;//记住密码
            }
            this.$axios.get('/api/user/login?name='+name+'&password='+password+'&rember='+rember).then(function(rs){
              that.redirect(rs.data);
              that.loading = false;
            });
          }
        })
      },
      redirect(data){
        if(data.success){
          if(data.data.id>0){
            this.$storage.setSession('uid',data.data.name);
            this.$storage.setSession('token',data.data.token);
            this.$Message.success(data.msg);
            //登录成功后直接获取权限
            this.$router.push({path:'/'});
          }else{
            alert('系统异常');
          }
        }else{
          this.$Message.error(data.msg+'，请检查账号密码');
          this.saveing=false;
        }
      },
    },
    created(){
      this.$Spin.hide();
    }
  }
</script>

<style scoped>
  .login-container {
    background-color:#F5F6F7;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin:0 auto;
    margin-top:10%;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    box-shadow: 0 0 25px #cac6c6;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue